import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ProjectScreen.css";
import ProjectPreview from "../../components/ProjectPreview/ProjectPreview";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DummyPoster from "../../assets/DummyPoster.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus-icon.svg";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import searchIcon from "../../assets/search.svg";
import uploadIcon from "../../assets/upload.svg";
import SortIcon from "../../assets/sort.svg";
import AppLogo from "../../assets/AppLogoBlue.svg";
import BackButton from "../../components/BackButton/BackButton";
import { useTranslation } from "react-i18next";
import AddProjectModal from "../../components/AddProjectModal/AddProjectModal";
import arrowDown from "../../assets/arrowDown.svg";
import Avatar from "../../components/Avatar/Avatar";
import { useAuth } from "../../context/AuthContext";
import {
  createVersion,
  deleteProject,
  deleteVersion,
  fetchProjectById,
  fetchProjectByIdForExplorer,
  fetchProjectByIdForAccess,
  fetchProjects,
  fetchProjectUsers,
  fetchSharedProjects,
  forceDeleteProject,
  forceDeleteVersion,
  getVersionUploadData,
  resetProjectsExplorer,
  setSharedProjectsStructure,
  updateSharedProjectChildren,
  updateProjectArchiveStatus,
  updateVersionArchiveStatus,
} from "../../store/projectsSlice";
import {
  projectsSelector,
  userSelector,
  currentOrganizationSelector,
  organizationUsersSelector,
  currentOrganizationOwnerSelector,
  isMainLoadedSelector,
  organizationsListSelector,
  currentUploadingVideosSelector,
  sharedProjectsStructureSelector,
} from "../../store/selectors";
import AddVersionModal from "../../components/AddVersionModal/AddVersionModal";
import VersionPreview from "../../components/VersionPreview/VersionPreview";
import ProjectExplorer from "../../components/ProjectExplorer/ProjectExplorer";
import { OrbitProgress } from "react-loading-indicators";
import UsersPopup from "../../components/VideoPage/UsersPopup";
import EditProjectModal from "../../components/EditProjectModal/EditProjectModal";
import EditProjectPosterModal from "../../components/EditProjectPosterModal/EditProjectPosterModal";
import {
  setCurrentUploadingVideosInfo,
  setIsMainLoaded,
} from "../../store/appSlice";
import ProjectSharePopup from "./ProjectSharePopup";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import BacklogPopup from "../../components/VideoPage/BacklogPopup";
import EditVersionModal from "../../components/EditVersionModal/EditVersionModal";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import SearchField from "../../components/SearchField/SearchField";
import useIsMobile from "../../hooks/useIsMobile";
import { updateTariffes } from "../../helpers/helpers";
import useOrganizationLimits from "../../hooks/useOrganizationLimits";
import toast from "react-hot-toast";
import { processShareToken } from "../../store/usersSlice";

function getQueryParam(search, param) {
  const params = new URLSearchParams(search);
  return params.get(param);
}

function ProjectScreen() {
  const dispatch = useDispatch();
  const { sharedToken } = useAuth();
  const isMobile = useIsMobile();
  const { projectId } = useParams();
  const location = useLocation();
  const project = useSelector((state) => state.projects.current);
  const [sharedProject, setSharedProject] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const projectsArray = useSelector(projectsSelector);
  const organizations = useSelector(organizationsListSelector);
  const navigate = useNavigate();
  const [showArchived, setShowArchived] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(true);
  const sharedProjectsStructure = useSelector(sharedProjectsStructureSelector);
  const [projectToRename, setProjectToRename] = useState(null);
  const [projectToChangeCover, setProjectToChangeCover] = useState(null);
  const user = useSelector(userSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [isOrgPopupOpen, setIsOrgPopupOpen] = useState(false);
  const [isBacklogPopupOpen, setBacklogPopupOpen] = useState(false);
  const limits = useOrganizationLimits();
  const [isAddSubprojectModalOpen, setIsAddSubprojectModalOpen] =
    useState(false);
  const [isAddVersionModalOpen, setIsAddVersionModalOpen] = useState(false);
  const [isUsersPopupOpen, setUsersPopupOpen] = useState(false);
  const [isVersionLoading, setIsVersionLoading] = useState(false);
  const [projectUsers, setProjectUsers] = useState([]);
  const [reuploadVersionId, setReuploadVersionId] = useState(null);
  const [sortOption, setSortOption] = useState("newest");
  const [showSortMenu, setShowSortMenu] = useState(false);
  const sortMenuRef = useRef(null);
  const isMainLoaded = useSelector(isMainLoadedSelector);
  const [reuploadedVersionId, setReuploadedVersionId] = useState(null);
  const [currentMegabytes, setCurrentMegabytes] = useState(0);
  const [totalMegabytes, setTotalMegabytes] = useState(0);

  const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);
  let checkingTimeout = useRef();
  const currentUploadingVideosInfo = useSelector(
    currentUploadingVideosSelector
  );
  const [versionToRename, setVersionToRename] = useState(null);
  const [isViewer, setIsViewer] = useState(false);
  const isShared = !!sharedToken;
  const actualProject = project || sharedProject;
  const [isRootSharedProject, setIsRootSharedProject] = useState(true);
  const [myProjectRole, setMyProjectRole] = useState(null);
  const isCommenterRole = !!myProjectRole && myProjectRole.role === "COMMENTER";
  const isViewerRole = !!myProjectRole && myProjectRole.role === "VIEWER";

  // isShared - человек незалогинен и прошел по шеринговой ссылке
  // isViewer - у человека доступ Viewer

  useEffect(() => {
    if (!actualProject || !user) return;
    dispatch(fetchProjectUsers(projectId)).then((res) => {
      if (!res.error) {
        let usersArray = res.payload;
        let myRole = usersArray.find((usr) => usr.userId === user.userId);
        if (!myRole && user) {
          const idsToCheck = actualProject.path;
          for (let i = idsToCheck.length - 1; i >= 0; i--) {
            const projectId = idsToCheck[i].id;
            const parentRole = user.projectRoles.find(
              (role) => role.projectId === projectId
            );
            if (parentRole) {
              myRole = {
                id: parentRole.id,
                role: parentRole.role,
                roleSourceProjectId: parentRole.projectId,
              };
              break;
            }
          }
        }
        if (myRole) {
          console.log("MY PROJECT ROLE IS ", myRole);
          setMyProjectRole(myRole);
        } else {
          console.log("NO MY PROJECT ROLE");
        }
      }
    });
  }, [actualProject, user]);

  useEffect(() => {
    clearTimeout(checkingTimeout.current);
    setIsPageLoading(true);
    if (window.location.href.includes("role=viewer")) {
      setIsViewer(true);
    } else {
      setIsViewer(false);
    }

    if (isShared) {
      dispatch(processShareToken(sharedToken)).then((res) => {
        if (!res.error) {
          if (res.payload.id !== +projectId) {
            setIsRootSharedProject(false);
            console.log("res here: ", projectId, ", ", res.payload);
            dispatch(
              fetchProjectByIdForAccess({
                projectId,
                showArchived: false,
                isShared: true,
              })
            ).then((res2) => {
              if (!res2.error) {
                const newSharedProject = res2.payload;
                setSharedProject(newSharedProject);
                const newSharedProjectChildren = [
                  ...newSharedProject.subprojects,
                  ...newSharedProject.versions,
                ];
                let mappedNewSharedProjectChildren = {};
                for (let i = 0; i < newSharedProjectChildren.length; i++) {
                  let entity = newSharedProjectChildren[i];
                  mappedNewSharedProjectChildren[entity.id] = {
                    id: entity.id,
                    isFolder: !entity.version,
                    isRoot: false,
                    isShared: true,
                    isUnfolded: false,
                    title: entity.version || entity.title,
                  };
                }
                // const newSharedProjectsStructure = {
                //   [newSharedProject.id]: {
                //     children: mappedNewSharedProjectChildren,
                //     id: newSharedProject.id,
                //     isFolder: true,
                //     isRoot: true,
                //     isShared: true,
                //     isUnfolded: true,
                //     title: newSharedProject.title,
                //   },
                // };
                dispatch(
                  updateSharedProjectChildren(
                    res2.payload.id,
                    mappedNewSharedProjectChildren,
                    res2.payload.path
                  )
                );
                // dispatch(
                //   setSharedProjectsStructure(newSharedProjectsStructure)
                // );
                setIsPageLoading(false);
                dispatch(setIsMainLoaded(true));
              }
            });
          } else {
            setIsRootSharedProject(true);
            const newSharedProject = res.payload;
            setSharedProject(newSharedProject);
            const newSharedProjectChildren = [
              ...newSharedProject.subprojects,
              ...newSharedProject.versions,
            ];
            let mappedNewSharedProjectChildren = {};
            for (let i = 0; i < newSharedProjectChildren.length; i++) {
              let entity = newSharedProjectChildren[i];
              mappedNewSharedProjectChildren[entity.id] = {
                id: entity.id,
                isFolder: !entity.version,
                isRoot: false,
                isShared: true,
                isUnfolded: false,
                title: entity.version || entity.title,
              };
            }
            const newSharedProjectsStructure = {
              [newSharedProject.id]: {
                children: mappedNewSharedProjectChildren,
                id: newSharedProject.id,
                isFolder: true,
                isRoot: true,
                isShared: true,
                isUnfolded: true,
                title: newSharedProject.title,
              },
            };
            dispatch(setSharedProjectsStructure(newSharedProjectsStructure));
            setIsPageLoading(false);
            dispatch(setIsMainLoaded(true));
          }

          // dispatch(setSharedProjectsStructure(newSharedProjectsStructure));
          // setIsPageLoading(false);
          // dispatch(setIsMainLoaded(true));
        }
      });

      return;
    }

    const queryShared = getQueryParam(location.search, "shared");
    const currentUserRole = user.projectRoles.find(
      (role) => role.projectId === +projectId
    );
    const isLoggedShared =
      (currentUserRole &&
        (currentUserRole.role === "COMMENTER" ||
          currentUserRole.role === "VIEWER")) ||
      queryShared;

    if (!isMainLoaded) {
      dispatch(fetchProjects({ organizationId: currentOrganization.id })).then(
        (res) => {
          if (!res.error) {
            dispatch(
              fetchProjectById({ projectId, showArchived, isLoggedShared })
            ).then(async (res2) => {
              if (
                res2 &&
                res2.payload &&
                res2.payload.versions &&
                res2.payload.versions.length
              ) {
                const verIndex = res2.payload.versions.findIndex((ver) => {
                  const isEmpty =
                    ver.videoStatus === "empty" || !ver.videoStatus;
                  const isPending = ver.videoStatus === "pending";
                  const isFinal = ver.status === "FINAL";
                  return isPending || (isEmpty && isFinal);
                });
                if (verIndex > -1) {
                  updateCurrentProject();
                }
              }
              if (!res2.error) {
                const path = res2.payload.path;
                if (path.length > 1) {
                  for (let i = 0; i < path.length; i++) {
                    const pathEntry = path[i];
                    await dispatch(
                      fetchProjectByIdForExplorer({
                        projectId: pathEntry.id,
                        showArchived,
                        isLoggedShared,
                      })
                    );
                  }
                }
                setIsPageLoading(false);
                dispatch(setIsMainLoaded(true));
              }
            });
            getUsersList();
          }
        }
      );
      dispatch(
        fetchSharedProjects({
          organizationId: currentOrganization.id,
          isDeleted: false,
        })
      );

      updateTariffes(user.organizations, dispatch);
    } else {
      dispatch(
        fetchProjectById({ projectId, showArchived, isLoggedShared })
      ).then((res) => {
        if (!res.error) {
          const fetchedProject = res.payload;
          setIsPageLoading(false);
          if (fetchedProject && fetchedProject.versions.length) {
            const verIndex = fetchedProject.versions.findIndex((ver) => {
              const isEmpty = ver.videoStatus === "empty" || !ver.videoStatus;
              const isPending = ver.videoStatus === "pending";
              const isFinal = ver.status === "FINAL";
              return isPending || (isEmpty && isFinal);
            });
            if (verIndex > -1) {
              updateCurrentProject();
            }
          }
        }
      });
      updateTariffes(user.organizations, dispatch);
      getUsersList();
    }

    return () => clearTimeout(checkingTimeout.current);
  }, [projectId, showArchived]);

  const updateCurrentProject = () => {
    clearTimeout(checkingTimeout.current);
    const queryShared = getQueryParam(location.search, "shared");
    const currentUserRole = user.projectRoles.find(
      (role) => role.projectId === +projectId
    );
    const isShared =
      (currentUserRole &&
        (currentUserRole.role === "COMMENTER" ||
          currentUserRole.role === "VIEWER")) ||
      queryShared;
    checkingTimeout.current = setTimeout(() => {
      dispatch(fetchProjectById({ projectId, showArchived, isShared })).then(
        (res) => {
          const updatedProj = res.payload;
          if (updatedProj && updatedProj.versions.length) {
            const verIndex = updatedProj.versions.findIndex((ver) => {
              const isEmpty = ver.videoStatus === "empty" || !ver.videoStatus;
              const isPending = ver.videoStatus === "pending";
              const isFinal = ver.status === "FINAL";
              const isInUploading = currentUploadingVideosInfo.find(
                (vidInfo) => vidInfo.data.id === ver.id
              );

              return !isInUploading && (isPending || (isEmpty && isFinal));
            });
            if (verIndex > -1) {
              updateCurrentProject();
            } else {
              updateTariffes(user.organizations, dispatch);
            }
          }
        }
      );
    }, 3000);
  };

  const handleCreateSubproject = async (projectData) => {
    const formData = new FormData();
    formData.append("title", projectData.title);
    formData.append("description", projectData.description);
    formData.append("organizationId", projectData.organizationId);
    formData.append("parentId", projectId);
    if (projectData.poster) {
      formData.append("poster", projectData.poster);
    }

    const result = await dispatch(createProject(formData));
    if (result.payload) {
      navigate(`/projects/${result.payload.id}`);
    }
  };

  const handleUploadVersion = (file) => {
    if (!!reuploadVersionId) {
      handleReuploadVersion(file);
      return;
    }
    setIsVersionLoading(true);
    let versionData = {
      name: file.name,
      status: "IN_PROGRESS",
    };
    dispatch(createVersion({ projectId, versionData })).then((res) => {
      if (!res.error) {
        const versionId = res.payload.id;
        let uploads = {};
        const uploadedVideoInfo = {
          file,
          data: res.payload,
          isUploaded: false,
          isCompleted: false,
          parentProjectId: project.id,
        };

        dispatch(
          setCurrentUploadingVideosInfo([
            ...currentUploadingVideosInfo,
            uploadedVideoInfo,
          ])
        );
        fetchCurrentProjectById();
        setIsVersionLoading(false);
        setIsAddVersionModalOpen(false);
        // let data = res.payload;
        // let upload_url =
        //   "https://" + "vod-uploader-2.edgevideo.ru" + "/upload/";

        // uploads[data.video.id] = new tus.Upload(file, {
        //   endpoint: upload_url,
        //   metadata: {
        //     filename: data.video.name,
        //     client_id: data.video.client_id,
        //     video_id: data.video.id,
        //     token: data.token,
        //   },
        //   onProgress: (bytesUploaded, bytesTotal) => {
        //     setCurrentMegabytes(bytesUploaded);
        //     setTotalMegabytes(bytesTotal);
        //   },
        //   onSuccess: function () {
        //     dispatch(
        //       updateVersion({
        //         versionId,
        //         title: file.name,
        //         status: "FINAL",
        //       })
        //     ).then((res) => {
        //       if (!res.error) {
        //         setIsVersionLoading(false);
        //         setIsAddVersionModalOpen(false);
        //         fetchCurrentProjectById();
        //         updateCurrentProject();
        //       }
        //     });
        //   },
        // });
        // uploads[data.video.id].start();
      } else {
        setIsVersionLoading(false);
      }
    });
  };

  const handleArchiveProject = (projectId, event) => {
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmArchive"))) {
      dispatch(
        updateProjectArchiveStatus({ projectId, isArchived: true })
      ).then((res) => {
        if (!res.error) {
          toast.success("Проект перемещен в архив");
          if (project.id === projectId) {
            navigate("/home");
          } else {
            fetchCurrentProjectById();
          }
        }
      });
    }
  };

  const handleRestoreProject = (projectId, event) => {
    event.stopPropagation();
    if (
      window.confirm(
        t("Вы действительно хотите восстановить проект из архива?")
      )
    ) {
      dispatch(
        updateProjectArchiveStatus({ projectId, isArchived: false })
      ).then((res) => {
        if (!res.error) {
          toast.success("Проект восстановлен из архива");
          fetchCurrentProjectById();
        }
      });
    }
  };

  const handleArchiveVersion = (versionId, event) => {
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmArchiveVersion"))) {
      dispatch(
        updateVersionArchiveStatus({ versionId, isArchived: true })
      ).then((res) => {
        if (!res.error) {
          toast.success("Версия перемещена в архив");
          fetchCurrentProjectById();
        }
      });
    }
  };

  const handleRestoreVersion = (versionId, event) => {
    event.stopPropagation();
    if (
      window.confirm("Вы действительно хотите восстановить версию из архива?")
    ) {
      dispatch(
        updateVersionArchiveStatus({ versionId, isArchived: false })
      ).then((res) => {
        if (!res.error) {
          toast.success("Версия восстановлена из архива");
          fetchCurrentProjectById();
        }
      });
    }
  };

  const handleDeleteProject = (projectId, event) => {
    event.stopPropagation();
    if (!showArchived) {
      if (window.confirm(t("projectScreen.confirmDelete"))) {
        dispatch(forceDeleteProject(projectId)).then((res) => {
          if (!res.error) {
            toast.success("Проект удален");
            if (project.id === projectId) {
              navigate("/home");
            } else {
              fetchCurrentProjectById();
            }
          }
        });
      }
      return;
    }
    if (window.confirm(t("projectScreen.confirmDelete"))) {
      dispatch(forceDeleteProject(projectId)).then((res) => {
        if (!res.error) {
          toast.success("Проект удален");
          if (project.id === projectId) {
            navigate("/home");
          } else {
            fetchCurrentProjectById();
          }
        }
      });
    }
  };

  const handleDeleteVersion = (versionId, event) => {
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmDeleteVersion"))) {
      dispatch(forceDeleteVersion(versionId)).then((res) => {
        if (!res.error) {
          toast.success("Версия удалена");
          fetchCurrentProjectById();
        }
      });
    }
  };

  const filteredVersions =
    (actualProject &&
      actualProject.versions &&
      actualProject.versions.filter(
        (ver) => ver.deletionStatus !== "MARKED_FOR_DELETE"
      )) ||
    [];

  // Combine subprojects and versions for the list
  const combinedList = [
    ...filteredVersions,
    ...(actualProject?.subprojects || []),
  ];

  const filteredCombinedList = combinedList.filter(
    (item) =>
      (!!item.title &&
        item.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (!!item.version &&
        item.version.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const handleRenameProject = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    setIsSharePopupOpen(false);
    if (projectId === project.id) {
      setProjectToRename(project);
      return;
    }
    const existingProject = combinedList.find((p) => p.id === projectId);
    setProjectToRename(existingProject);
  };

  const handleChangeCover = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    setIsSharePopupOpen(false);
    if (projectId === project.id) {
      setProjectToChangeCover(project);
      return;
    }
    const existingProject = combinedList.find((p) => p.id === projectId);
    setProjectToChangeCover(existingProject);
  };

  const openVersionModalForReupload = (versionId) => {
    setIsAddVersionModalOpen(true);
    setReuploadVersionId(versionId);
  };

  const handleReuploadVersion = (file) => {
    setIsVersionLoading(true);
    dispatch(getVersionUploadData(reuploadVersionId)).then((res) => {
      if (!res.error) {
        let uploads = {};
        const uploadedVideoInfo = {
          file,
          data: res.payload,
          isCompleted: false,
          parentProjectId: project.id,
        };

        dispatch(
          setCurrentUploadingVideosInfo([
            ...currentUploadingVideosInfo,
            uploadedVideoInfo,
          ])
        );
        setIsVersionLoading(false);
        setIsAddVersionModalOpen(false);
      } else {
        setIsVersionLoading(false);
      }
    });
  };
  // Sorting logic
  const getSortedCombinedList = (list) => {
    let arr = [...list];
    switch (sortOption) {
      case "newest":
        arr.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
        break;
      case "oldest":
        arr.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
        break;
      case "az":
        arr.sort((a, b) =>
          (a.title || a.version || "").localeCompare(
            b.title || b.version || "",
            "ru"
          )
        );
        break;
      case "za":
        arr.sort((a, b) =>
          (b.title || b.version || "").localeCompare(
            a.title || a.version || "",
            "ru"
          )
        );
        break;
      default:
        break;
    }
    return arr;
  };

  const sortedCombinedList = getSortedCombinedList(filteredCombinedList);
  // Adjust renderProject to handle both subprojects and versions
  const renderItem = (item, index) => {
    // If it's a version, it may not have a title, so use name or title
    const isVersion = !!item.version;

    if (isVersion) {
      let neededItem = item;
      const currentlyUploadingVideo =
        currentUploadingVideosInfo.length &&
        currentUploadingVideosInfo.find((vid) => vid.data.id === item.id);

      return (
        <VersionPreview
          isShared={isShared}
          versionInfo={neededItem}
          item={neededItem}
          currentlyUploadingVideo={currentlyUploadingVideo}
          vidStatus={neededItem.videoStatus}
          uploadStatus={currentlyUploadingVideo}
          project={project}
          key={neededItem.id}
          onClick={() => {
            if (!showArchived) {
              if (isShared && isViewer) {
                navigate(`/video/${neededItem.id}?shared=1&role=viewer`);
              } else if (isShared && !isViewer) {
                navigate(`/video/${neededItem.id}?shared=1`);
              } else {
                navigate(`/video/${neededItem.id}`);
              }
            }
          }}
          onDelete={handleDeleteVersion}
          onArchive={handleArchiveVersion}
          onRestore={handleRestoreVersion}
          reuploadVersion={openVersionModalForReupload}
          reuploadedVersionId={reuploadedVersionId}
          setReuploadedVersionId={setReuploadedVersionId}
          isArchive={showArchived}
          fetchCurrentProjectById={fetchCurrentProjectById}
        />
      );
    }
    return (
      <ProjectPreview
        isShared={isShared}
        isCommenterRole={isCommenterRole}
        isViewerRole={isViewerRole}
        index={index}
        projectInfo={item}
        key={item.id}
        onClick={() => {
          if (!showArchived) {
            if (isShared && isViewer) {
              navigate(`/projects/${item.id}?shared=1&role=viewer`);
            } else if (
              (isShared && !isViewer) ||
              isCommenterRole ||
              isViewerRole
            ) {
              navigate(`/projects/${item.id}?shared=1`);
            } else {
              navigate(`/projects/${item.id}`);
            }
          }
        }}
        onDelete={handleDeleteProject}
        onArchive={handleArchiveProject}
        onRestore={handleRestoreProject}
        isArchive={showArchived}
        onRename={(e) => handleRenameProject(e, item.id)}
        onChangeCover={(e) => handleChangeCover(e, item.id)}
        fetchCurrentProjectById={fetchCurrentProjectById}
      />
    );
  };

  const getPageTitle = () => {
    if ((!project && !sharedProject) || isPageLoading) return "Загрузка...";
    const neededProject = project || sharedProject;
    const projectPath = neededProject.path;
    let projectTitle = projectPath.reduce((res, current) => {
      res += `${current.title} • `;
      return res;
    }, "");
    return projectTitle.slice(0, projectTitle.length - 3);
  };

  const fetchCurrentProjectById = () => {
    dispatch(fetchProjectById({ projectId, showArchived })).then((res) => {
      if (!res.error) {
        updateTariffes(user.organizations, dispatch);
      }
    });
  };

  const handleOrganizationChange = (organization) => {
    setIsPageLoading(true);
    dispatch({ type: "SET_CURRENT_ORGANIZATION", payload: organization });
    dispatch(
      fetchProjects({
        organizationId: organization.id,
        isDeleted: showArchived,
      })
    ).then((res) => {
      if (!res.error) {
        setIsPageLoading(false);
        dispatch(resetProjectsExplorer());
        navigate("/home");
      }
    });
    setShowOrganizationPopup(false);
  };

  const onPressAddOrganization = () => {
    setShowOrganizationPopup(false);
  };

  useEffect(() => {
    if (!showSortMenu) return;
    const handleClickOutside = (event) => {
      if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
        setShowSortMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSortMenu]);

  const getUsersList = () => {
    dispatch(fetchProjectUsers(projectId)).then((res) => {
      if (!res.error) {
        let usersArray = res.payload;
        var unique = usersArray.filter(
          (value, index, array) =>
            array.findIndex((val) => val.email === value.email) === index
        );
        setProjectUsers(unique);
      }
    });
  };

  return (
    <div
      className={isMobile ? "projectScreen-App-mobile" : "projectScreen-App"}
    >
      <div
        className={
          isMobile ? "projectScreen-header-mobile" : "projectScreen-header"
        }
      >
        <div
          className={
            isMobile
              ? "projectScreen-header-left-mobile"
              : "projectScreen-header-left"
          }
        >
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home")}
            className={
              isMobile
                ? "projectScreen-logoBlock-mobile"
                : "projectScreen-logoBlock"
            }
          >
            <img src={AppLogo} style={{ height: "80%" }} />
            {(isShared && !isViewer && (
              <button
                style={{
                  backgroundColor: "#4477ff",
                  border: "none",
                  padding: 10,
                  color: "white",
                  marginLeft: 20,
                  borderRadius: 80,
                  cursor: "pointer",
                }}
                onClick={() => {
                  window.location.href = "https://go.7cut.video";
                }}
              >
                Войти
              </button>
            )) ||
              null}

            {/* <span className="projectScreen-logo-text">
              {t("mainScreen.title")}
            </span> */}
          </div>
          {!isMobile && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {(!isShared || !isRootSharedProject) && (
                <BackButton onClick={() => navigate(-1)} />
              )}
              <span className="projectScreen-page-title">{getPageTitle()}</span>
            </div>
          )}
        </div>

        {/* <div className="language-switcher">
            <button
              className={`lang-button ${
                i18n.language === "ru" ? "active" : ""
              }`}
              onClick={() => changeLanguage("ru")}
            >
              RU
            </button>
            <button
              className={`lang-button ${
                i18n.language === "en" ? "active" : ""
              }`}
              onClick={() => changeLanguage("en")}
            >
              EN
            </button>
          </div> */}
        <div className="projectScreen-header-actions">
          {!isMobile && (
            <>
              <SearchField
                isShared={isShared}
                onValueChanged={(value) => setSearchQuery(value)}
              />
            </>
          )}
          {!isShared && (
            <>
              <NotificationsPopup />
              <ProfilePopup />
            </>
          )}
        </div>
      </div>
      <div className="projectScreen-content">
        {(!isMobile || isMenuOpen) && (
          <ProjectExplorer
            isShared={isShared}
            isViewer={isViewer}
            isMobile={isMobile}
            organizations={organizations}
            projectsArray={projectsArray}
            currentProject={actualProject}
            currentOrganization={currentOrganization}
            isOrgPopupOpen={isOrgPopupOpen}
            onOrganizationSelect={handleOrganizationChange}
            onAddOrganization={onPressAddOrganization}
            onOrganizationClick={() => setIsOrgPopupOpen(!isOrgPopupOpen)}
            projectUsers={projectUsers}
            isPageLoading={!isMainLoaded}
            showArchived={showArchived}
          />
        )}
        <div className="projectScreen-folders">
          {!isPageLoading && (
            <>
              <div className="projectScreen-folders-header">
                <div style={{ position: "relative", maxWidth: "68%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => {
                      if (
                        isShared ||
                        isCommenterRole ||
                        isViewerRole ||
                        showArchived
                      )
                        return;
                      setIsSharePopupOpen((v) => !v);
                    }}
                  >
                    <div className="projectScreen-poster-thumb">
                      <img
                        src={
                          (actualProject && actualProject.posterUrl) ||
                          DummyPoster
                        }
                        style={{ height: "100%", width: "auto" }}
                      />
                    </div>
                    <span
                      className={
                        isMobile
                          ? "projectScreen-title-mobile"
                          : "projectScreen-title"
                      }
                    >
                      {actualProject &&
                        (showArchived
                          ? `Архив: ${actualProject.title}`
                          : actualProject.title)}
                    </span>
                    {!isShared &&
                      !isCommenterRole &&
                      !isViewerRole &&
                      !showArchived && (
                        <img
                          src={arrowDown}
                          alt="arrow"
                          style={{
                            width: 6,
                            height: 6,
                            transform: isSharePopupOpen
                              ? "rotate(180deg)"
                              : "none",
                          }}
                        />
                      )}
                  </div>
                  {isSharePopupOpen && (
                    <ProjectSharePopup
                      project={project}
                      onClose={() => setIsSharePopupOpen(false)}
                      onOpenBacklog={() => setBacklogPopupOpen(true)}
                      onChangeCover={(e) => handleChangeCover(e, project.id)}
                      onRename={(e) => handleRenameProject(e, project.id)}
                      onDelete={handleDeleteProject}
                      onArchive={handleArchiveProject}
                      className={
                        isMobile
                          ? "project-share-popup-context-menu-absolute-mobile"
                          : "project-share-popup-context-menu-absolute"
                      }
                    />
                  )}
                  {isBacklogPopupOpen && (
                    <BacklogPopup
                      isOpen={isBacklogPopupOpen}
                      onClose={() => setBacklogPopupOpen(false)}
                    />
                  )}
                </div>

                <div className="main-projects-filter-buttons">
                  {!isShared && !isCommenterRole && !isViewerRole && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        display: showArchived ? "none" : "flex",
                      }}
                    >
                      <button
                        className="projectScreen-add-folder-btn"
                        onClick={() => {
                          if (!limits) {
                            toast.error(
                              "У рабочего пространства отсутствует тариф"
                            );
                            return;
                          }
                          const projectsLimit = limits.find(
                            (limit) =>
                              limit.attributeCode === "AVAILABLE_PROJECT_COUNT"
                          );
                          if (
                            projectsLimit &&
                            projectsLimit.usedValue >= projectsLimit.maxValue
                          ) {
                            toast.error(
                              "Ваш текущий тариф не позволяет создать большее количество проектов."
                            );
                            return;
                          }
                          setIsAddSubprojectModalOpen(true);
                        }}
                      >
                        <PlusIcon
                          className="main-projects-add-btn-plus-icon"
                          style={{
                            transform: "scale(0.9)",
                          }}
                        />
                        {!isMobile && t("mainScreen.projects.addFolder")}
                      </button>
                      <button
                        className="projectScreen-add-version-btn"
                        onClick={() => {
                          setIsAddVersionModalOpen(true);
                          setReuploadVersionId(null);
                        }}
                      >
                        <img
                          src={uploadIcon}
                          alt="plus"
                          width={24}
                          height={24}
                        />
                        {!isMobile && t("mainScreen.projects.addVersion")}
                      </button>
                    </div>
                  )}
                </div>
                {!isMobile && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    {!isShared && !isCommenterRole && !isViewerRole && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button
                          className={`filter-btn ${
                            !showArchived ? "filter-btn--active" : ""
                          }`}
                          onClick={() => setShowArchived(false)}
                        >
                          {t("mainScreen.projects.filter.all")}
                        </button>

                        <button
                          className={`filter-btn ${
                            showArchived ? "filter-btn--active" : ""
                          }`}
                          style={{ marginLeft: 5 }}
                          onClick={() => setShowArchived(true)}
                        >
                          {t("mainScreen.projects.filter.archived")}
                        </button>
                      </div>
                    )}

                    <div>
                      <div
                        ref={sortMenuRef}
                        style={{
                          width: 32,
                          height: 32,
                          marginLeft: 10,
                          backgroundColor: "transparent",
                          boxShadow: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                        onClick={() => setShowSortMenu((v) => !v)}
                      >
                        <img src={SortIcon} style={{ width: 28, height: 28 }} />
                        {showSortMenu && (
                          <div className="project-sort-menu">
                            <div
                              className={`project-sort-menu-item${
                                sortOption === "newest" ? " selected" : ""
                              }`}
                              onClick={(event) => {
                                event.stopPropagation();
                                setSortOption("newest");
                                setShowSortMenu(false);
                              }}
                            >
                              {sortOption === "newest" ? "✓ " : ""}Сначала новые
                            </div>
                            <div
                              className={`project-sort-menu-item${
                                sortOption === "oldest" ? " selected" : ""
                              }`}
                              onClick={(event) => {
                                event.stopPropagation();
                                setSortOption("oldest");
                                setShowSortMenu(false);
                              }}
                            >
                              {sortOption === "oldest" ? "✓ " : ""}Сначала
                              старые
                            </div>
                            <div
                              className={`project-sort-menu-item${
                                sortOption === "az" ? " selected" : ""
                              }`}
                              onClick={(event) => {
                                event.stopPropagation();
                                setSortOption("az");
                                setShowSortMenu(false);
                              }}
                            >
                              {sortOption === "az" ? "✓ " : ""}От А до Я
                            </div>
                            <div
                              className={`project-sort-menu-item${
                                sortOption === "za" ? " selected" : ""
                              }`}
                              onClick={(event) => {
                                event.stopPropagation();
                                setSortOption("za");
                                setShowSortMenu(false);
                              }}
                            >
                              {sortOption === "za" ? "✓ " : ""}От Я до А
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div
                className={
                  isMobile ? "projectScreen-list-mobile" : "projectScreen-list"
                }
              >
                {sortedCombinedList.length === 0 && (
                  <div className="projectScreen-projects-container-dummy">
                    <div className="projectScreen-projects-container-dummy-title">
                      {showArchived
                        ? "В архиве пока ничего нет"
                        : t("mainScreen.projects.folderDummy.title")}
                    </div>
                    <span className="projectScreen-projects-container-dummy-subtitle">
                      {showArchived
                        ? "Проекты и версии появятся здесь после того, как вы отправите их в архив"
                        : t("mainScreen.projects.folderDummy.subtitle")}
                    </span>
                  </div>
                )}
                {sortedCombinedList.length !== 0 &&
                  sortedCombinedList.map((item, index) =>
                    renderItem(item, index)
                  )}
              </div>
            </>
          )}
          {isPageLoading && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OrbitProgress color="#C1C7D4" />
            </div>
          )}
        </div>
      </div>
      {showOrganizationPopup && (
        <div className="modal-overlay">
          <div className="modal-content organization-popup">
            <h2>{t("mainScreen.organization.title")}</h2>
            <div className="organization-list">
              {organizations.map((org) => (
                <div key={org.id} className="organization-item">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="organization"
                      checked={currentOrganization.id === org.id}
                      onChange={() => handleOrganizationChange(org)}
                    />
                    <span title={org.title || org.name || org.email}>
                      {(org.title || org.name || org.email).length > 40
                        ? (org.title || org.name || org.email).slice(0, 40) +
                          "..."
                        : org.title || org.name || org.email}
                    </span>
                  </label>
                </div>
              ))}
            </div>
            <button
              className="org-close-button"
              onClick={() => setShowOrganizationPopup(false)}
            >
              {t("common.close")}
            </button>
          </div>
        </div>
      )}
      {projectToRename && (
        <EditProjectModal
          project={projectToRename}
          fetchCurrentProjectById={fetchCurrentProjectById}
          currentProject={project}
          onRenamed={() => {
            fetchCurrentProjectById();
          }}
          onClose={() => setProjectToRename(null)}
        />
      )}
      {versionToRename && (
        <EditVersionModal
          fetchCurrentProjectById={fetchCurrentProjectById}
          version={{ version: versionToRename, versionId: versionToRename.id }}
          status={versionToRename.videoStatus}
          currentProject={project}
          onClose={() => setVersionToRename(null)}
          onRenamed={() => {
            fetchCurrentProjectById();
          }}
        />
      )}
      {projectToChangeCover && (
        <EditProjectPosterModal
          project={projectToChangeCover}
          fetchCurrentProjectById={fetchCurrentProjectById}
          currentProject={project}
          onPosterUpdated={() => {
            fetchCurrentProjectById();
            setProjectToChangeCover(null);
          }}
          onClose={() => setProjectToChangeCover(null)}
        />
      )}
      {isAddSubprojectModalOpen && (
        <AddProjectModal
          parentId={projectId}
          onClose={() => setIsAddSubprojectModalOpen(false)}
          onSubmit={handleCreateSubproject}
        />
      )}

      {isAddVersionModalOpen && (
        <AddVersionModal
          project={project}
          isVersionLoading={isVersionLoading}
          currentMegabytes={currentMegabytes}
          totalMegabytes={totalMegabytes}
          onClose={() => setIsAddVersionModalOpen(false)}
          onSubmit={handleUploadVersion}
        />
      )}
      {isUsersPopupOpen && (
        <UsersPopup
          projectInfo={project}
          isOpen={isUsersPopupOpen}
          onClose={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setUsersPopupOpen(false);
          }}
          usersArray={projectUsers}
          updateUsersArray={getUsersList}
        />
      )}
    </div>
  );
}

export default ProjectScreen;
